import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";
import qs from "qs";

import Button from "../../components/button";
import Accordion from "./Accordion";
import IconArrow from "../../components/icons/arrow";
import { loadFaq } from "../../redux/actions/faq";
import { changeMobileFaq } from "../../redux/actions/options";

class Faq extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAccordion: "",
            themeSelected: "",
        };

        this._onAccordionPress = this._onAccordionPress.bind(this);
        this._onThemePress = this._onThemePress.bind(this);
    }

    componentDidMount() {
        this.props.loadFaq();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isLoading !== prevProps.isLoading) {
            if (this.props.faqData && this.props.faqData.length > 0) {
                if (this.props.type === "faq") this._onScroll();
            }
        }
    }

    _onScroll() {
        const params = qs.parse(location.search, { ignoreQueryPrefix: true });

        setTimeout(() => {
            if (params.name) {
                this.setState({
                    themeSelected: params.name,
                });
            }

            scroller.scrollTo("container-faq", {
                duration: 700,
                smooth: true,
            });
        }, 300);
    }

    _onAccordionPress(id) {
        this.setState({
            currentAccordion: id === this.state.currentAccordion ? "" : id,
        });
    }

    _renderTheme(faq, index) {
        const { themeSelected } = this.state;

        let isActive = false;

        if (themeSelected === "" && index === 0) {
            isActive = true;
        } else {
            isActive = faq.name === themeSelected;
        }

        return (
            <Button
                key={faq.order}
                text={faq.name}
                backgroundColor={isActive ? "bg-orange" : "bg-maize"}
                backgroundColorOver={"bg-orange"}
                borderColor={"border-orange"}
                textStyle={
                    isActive
                        ? "font-bold text-center text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-maize text-maize"
                        : "font-bold text-center text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-maize text-orange"
                }
                height={"h-50"}
                style={"w-310 mb-12"}
                onClick={this._onThemePress}
            />
        );
    }

    _onThemePress(theme) {
        this.setState({
            themeSelected: theme,
        });
    }

    render() {
        const { faqData } = this.props;
        const { themeSelected, currentAccordion } = this.state;

        if (!faqData || faqData.length === 0) return null;

        let faqDataTheme = faqData[0];
        if (themeSelected !== "")
            faqDataTheme = faqData.filter(
                (item) => item.name === themeSelected
            )[0];

        return (
            <div
                name="container-faq"
                className="bg-maize pt-60 xl:pt-100 pb-60 xl:pb-100 px-16 xl:px-50"
            >
                <h1 className="font-judge font-bold text-50 xl:text-100 text-orange mb-40 xl:mb-100 text-center">
                    {"FAQS"}
                </h1>
                <div className="xl:hidden flex-col w-full">
                    {faqData.map((faq, index) => (
                        <div
                            key={index}
                            className="flex border-t border-orange items-center"
                        >
                            <Link
                                onClick={() => {
                                    this.props.changeMobileFaq(true, faq.name);
                                }}
                                className={
                                    "text-17 font-judge font-bold py-12 flex-1 text-orange"
                                }
                                title={faq.name}
                            >
                                {faq.name}
                            </Link>
                            <IconArrow className="cursor-pointer text-orange transform rotate-90" />
                        </div>
                    ))}
                    <div className="border-t border-orange" />
                </div>
                <div className="hidden xl:flex">
                    <div className="flex-1">
                        {faqData.map((faq, index) =>
                            this._renderTheme(faq, index)
                        )}
                    </div>
                    <div className="w-8/12">
                        {faqDataTheme.content.map((item) => (
                            <Accordion
                                id={item.key}
                                key={item.key}
                                section={item.attributes}
                                current={currentAccordion}
                                onPress={this._onAccordionPress}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    faqData: state.faq.data,
    isLoading: state.faq.isLoading,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeMobileFaq,
            loadFaq,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Faq);
